import { FormDefinition } from 'app/form_config/FormController';
import { ImsObject } from './ims_object';
import { Cesium } from 'app/cesium';
import { createCesiumColorForStrOrArrayColor } from '../utilities/ims_color';

export const IMS_TYPE__IP_DEVICE_TYPE = 'ip_device_type';

export class IpDeviceType extends ImsObject {
    show: boolean;
    _cesiumColor: Cesium.Color;
    /**
     * the form definitions that was dynamically generated from the dynamic stat schemas
     */
    _dynamicallyGeneratedForms: Array<FormDefinition>;

    constructor(resource) {
        super(IMS_TYPE__IP_DEVICE_TYPE, resource);
        // Referenced to determine if assets should be shown or hidden
        this.show = true;
        this._cesiumColor = createCesiumColorForStrOrArrayColor(this.cesiumColorString);
    }

    get image_name() {
        return this.resource.image_name;
    }

    get name() {
        return this.resource.name;
    }

    get category() {
        return this.resource.category;
    }

    get cesiumColorString(): string {
        return this.resource.color ? this.resource.color.cesium : 'WHITE';
    }

    get cesiumColor(): Cesium.Color {
        return this._cesiumColor;
    }

    get selectable() {
        return this.resource.selectable;
    }

    get editable_radios() {
        return this.resource.editable_radios;
    }

    get supported_radio_types() {
        return this.resource.supported_radio_types;
    }

    get forms(): Array<FormDefinition> {
        return this.resource.forms || [];
    }

    get dynamicallyGeneratedForms(): Array<FormDefinition> {
        // if the forms have not been generated yet -> populate them!!
        return this._dynamicallyGeneratedForms;
    }

    set dynamicallyGeneratedForms(dynamicallyGeneratedForms: Array<FormDefinition>) {
        this._dynamicallyGeneratedForms = dynamicallyGeneratedForms;
    }

    public hasPopulatedDynamicallyGeneratedForms(): boolean {
        return this._dynamicallyGeneratedForms !== undefined;
    }

    static toFilterable(ipDeviceType: IpDeviceType): object {
        return {
            name: ipDeviceType.name,
            category: ipDeviceType.category,
            supported_radio_types: ipDeviceType.supported_radio_types,
        };
    }
}
